import MDTypography from "components/MDTypography";
import { Button, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Add } from "@mui/icons-material";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";

function CTLNONWorkingAction({ row, onAdd, onDelete, onEdit, onDeactivate }) {
  const condition = row?.original?.date;
  const isActive = row?.original?.isActive;
  return (
    <MDTypography variant="caption" fontWeight="medium" color="text">
      <tooltip title="Add">
        {onAdd && !condition && (
          <IconButton color="info" onClick={() => onAdd(row.original)}>
            <Add></Add>
          </IconButton>
        )}
      </tooltip>
      <tooltip title="Update">
        {onEdit && (
          <IconButton color="success" onClick={() => onEdit(row.original)}>
            <OpenInNewIcon></OpenInNewIcon>
          </IconButton>
        )}
      </tooltip>
      <tooltip title={"Delete"}>
        {onDelete && condition && (
          <IconButton color="error" onClick={() => onDelete(row.original)}>
            <DeleteIcon />
          </IconButton>
        )}
      </tooltip>
      <tooltip title={isActive ? "Enabled" : "Disabled"}>
        {onDeactivate && (
          <IconButton
            color={isActive ? "success" : "error"}
            onClick={() => onDeactivate(row.original)}
          >
            {isActive ? <DoneIcon /> : <CloseIcon />}
          </IconButton>
        )}
      </tooltip>
    </MDTypography>
  );
}

export default CTLNONWorkingAction;
